import httpClient from "../http/http-client";
import { IConversionFactorCustom, IPostConversionFactorCustom } from './conversion-factor-custom.model';

export default class ConversionFactorCustomService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAllWithPagination(
    page: number,
    perPage: number = 10,
    orderBy?: string,
    order?: 'asc' | 'desc',
    filters?: {
      search?: string;
      secrMappingStatus?: string;
      scope?: string;
      secrSourceKey?: string;
    }
  ): Promise<{ count: number; rows: IConversionFactorCustom[] }> {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('perPage', String(perPage));
    if (orderBy) params.set('orderBy', orderBy);
    if (order) params.set('order', order);
    if (filters?.search?.trim()) params.set('search', filters.search.trim());
    if (filters?.secrMappingStatus) params.set('secrMappingStatus', filters.secrMappingStatus);
    if (filters?.scope) params.set('scope', filters.scope);
    if (filters?.secrSourceKey) params.set('secrSourceKey', filters.secrSourceKey);
    return this.http
      .get(`conversion-factor-custom?${params.toString()}`)
      .then((response) => response.data)
      .catch((err) => {
        throw err;
      });
  }

  async getOne(conversionFactorCustomId: string): Promise<IConversionFactorCustom> {
    return this.http.get(`conversion-factor-custom/${conversionFactorCustomId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async create(conversionFactorCustom: IPostConversionFactorCustom): Promise<IConversionFactorCustom> {
    return this.http.post(`conversion-factor-custom`, conversionFactorCustom)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async edit(conversionFactorCustomId: string, conversionFactorCustom: Partial<IPostConversionFactorCustom>): Promise<IConversionFactorCustom> {
    return this.http.patch(`conversion-factor-custom/${conversionFactorCustomId}`, conversionFactorCustom)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async createConversionSourceYear(conversionSourceId: string, year: string): Promise<void> {
    return this.http.post(`conversion-factor-custom/conversion-source-year/${conversionSourceId}`, { conversionYear: year })
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}


